import React, { FC } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ButtonWithChevronWithLink } from '../ButtonWithChevron/ButtonWithChevron';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material';
import { IOverviewMachines } from '../../models/UserOverview';
import { useTranslation } from 'react-i18next';
import { OverviewLicenses } from './OverviewLicenses';
import { AuthenticatedRoutes } from '../../routers/AuthenticatedRoutes';

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: '100%',
  padding: `${theme.spacing(2)} 11%`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const TableContainer = styled('div')({
  maxHeight: 300,
  overflowY: 'auto',
});

interface IProps {
  licenses: IOverviewMachines;
}

export const ProductLicensesOverview: FC<IProps> = ({ licenses }) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} lg={4}>
      <StyledPaper>
        <div>
          <Typography variant="h4" textAlign="center">
            {t('userOverview.productOverview.licensesInUseValue', {
              used: licenses.licensesInUse,
              total: licenses.licensesAvailable,
            })}
          </Typography>
          <Typography variant="subtitle1" textAlign="center" marginBottom={2}>
            {t('userOverview.productOverview.licensesInUse')}
          </Typography>

          <TableContainer>
            <OverviewLicenses licenses={licenses} />
          </TableContainer>
        </div>

        <ButtonWithChevronWithLink to={AuthenticatedRoutes.Licenses()}>
          {t('userOverview.productOverview.goToLicenses')}
        </ButtonWithChevronWithLink>
      </StyledPaper>
    </Grid>
  );
};
